/* 表单配置 */

import {
    GET,
    GETNEW,
    POST,
    PUT,
    PUTNEW,
    POSTNEW,
    DELETEBODY,
    DELETEBODYNEW,
    DELETE,
    DELETENEW,
    download,
    uploading,
    POSTFormData,
    EXPORT,
    EXPORTNEW,
    POSTFormDataNEW
} from '@/request/http'

// 获取表单类型接口
export const getFormType = p => GETNEW('/dataform/config/form-type/list', p)
// (老师)个人问卷-查看自己创建的表单
export const getOneselfPage = p => POSTNEW('/dataform/form/oneself/page', p)
// (老师)公共问卷 - 查看已经发布的所有表单
export const getReleasePage = p => POSTNEW('/dataform/form/release/page', p)
//（步骤-表单属性）获取表单属性信息
export const getFormItem = p => GETNEW('/dataform/form-item/get-items', p)
//（步骤-表单范围）获取所选范围的学生数
export const getFindScopeCount = p => POSTNEW('/dataform/form-score/findScopeCount', p)
//题类型-获取题类型接口（分组）
export const getQuestionType = p => GETNEW('/dataform/config/question-type/list', p)
//表单创建-获取不重复的ID
export const getDifferentId = p => GETNEW('/dataform/form/getId', p)
// 查询校区公寓接口
export const getDormTwo = p => GETNEW('/dormv2/location/getCampusBuildingTree', p)
// 步骤-表单范围-学生名单分页查询
export const getPageStudent = p => POSTNEW('/dataform/form-score/pageStudent', p)
// 步骤-表单范围 - 添加学生提交接口
export const addStudentFormScore = p => POSTNEW('/dataform/form-score/addStudent', p)
// 步骤-表单范围-从名单中移除学生
export const deleteChangeStudent = p => POSTNEW('/dataform/form-score/removeStudent', p)
// 步骤-表单范围 - 指定学生名单导入接口
export const importStudentAdd = p => POSTFormData('/dataform/form-score/importStudent', p)
// 步骤-编辑题-获取自增题列支持的题型
export const getQuestionTypeAdd = p => GETNEW('/dataform/config/question-type/list/ADD_QUESTION', p)
// 提交接口 - 表单创建、修改、复制表单提交接口
export const submitDataFormInfo = p => POSTNEW('/dataform/form/save', p)
// 表单 - 修改状态：发布、停用
export const formDataUpdateStatus = p => POSTNEW('/dataform/form/updateStatus', p)
// 步骤-编辑题 - 获取题信息，用于编辑页面用
export const getFindUpdateInfoList = p => GETNEW('/dataform/form-question/findUpdateInfo', p)
// 步骤-表单属性 - 获取表单属性信息
export const getFormItemEdit = p => GETNEW('/dataform/form-item/get-items', p)
// 步骤-表单范围-获取范围信息，用于回显
export const getScopeInfoEdit = p => GETNEW('/dataform/form-score/getScopeInfo', p)
// 获取表单基本信息,用于回显
export const getContentFormInfo = p => GETNEW('/dataform/form/getContentFormInfo', p)
// 查询动态字段接口(查询表头)
export const getFormDataRecords = p => GETNEW('/dataform/query-config/getRecords', p)
// 分页查询接口（PC端查看结果）
export const getFindAnswerPage = p => POSTNEW('/dataform/answer/findAnswerPage', p)
// 表单页导出
export const exportAnswerDataForm = p => POSTNEW('/dataform/answer/exportAnswer', p)
// 表单页导出图片
export const exportAnswerDataPhoto = p => POSTNEW('/dataform/answer/exportDataPhoto', p)
// 获取学生的表单回答详情接口（教师端审核查看学生回答详情用）
export const getStudentFormAnswerInfo = p => GETNEW('/dataform/answer/getStudentFormAnswerInfo', p)
// 获取学生的表单回答详情接口（教师端审核查看学生回答详情用新）
export const getStudentFormAnswerNewInfo = p => GETNEW('/dataform/answer/getStudentFormAnswerInfoAndPhoto', p)
// 通过身份证号获取毕业证照片
export const getStudentPhotoByCardId = p => POSTNEW('/studentv2/photo/getUrlByIdCardNo', p)
// 表单审批提交
export const formDataAnswerAudit = p => POSTNEW('/dataform/answer/audit', p)
// 表单审批提交新
export const formDataAnswerAuditNew = p => POSTNEW('/dataform/answer/auditPhoto', p)
// 表单清除学生答题数据
export const formDataRemoveAnswer = p => POSTNEW('/dataform/answer/removeAnswer', p)
// 导入下载模板
export const getConfigOnload = p => GETNEW('/dataform/form-config/getConfig', p)
// 删除表单
export const formDataDelete = p => POSTNEW('/dataform/form/remove-form', p)
// 获取所有审核人
export const getAllEditPeople = p => GETNEW('/basic/departments/dept-person-tree', p)



// WEBPACK FOOTER //
// ./src/api/modules/formConfiguration.js